/** How a live conversation is named on Home and in the bubble: its origin, then what it is about. */
export function sessionLabel(session) {
  if (session.origin === 'initiative') return `Initiative · ${session.initiative_title || session.title || 'Autonomous work'}`;
  return `Chat · ${session.title || 'Conversation'}`;
}
